// SSE is an invalidation hint. The persisted HTTP snapshot is always authoritative.
const events=['PRESENTER_CONNECTED','ANNOUNCEMENT_STARTED','ANNOUNCEMENT_COMPLETED','DRAW_READY','LIVE_DRAW_STARTED','DRAW_STARTED','DRAW_CELEBRATION','DRAW_RESULTS_AVAILABLE','DRAW_RESULTS_REPLAY','DRAW_STATE_CHANGED','DRAW_CANCELLED','DRAW_CELEBRATION_STARTED','DRAW_FINALIZATION_FAILED','DRAW_COMPLETED'];
export function connectDraw({url,refresh,onStatus=()=>{},onReconnect=()=>{}}) {
  let source,closed=false,inFlight=false,queued=false,poll,retry,watchdog,failures=0,attempt=0;
  let lastId='',connected=false;
  const diagnostic=(event,detail={})=>console.info(JSON.stringify({component:'draw-connection',event,...detail}));
  const later=(n)=>Math.min(30000,1000*2**Math.min(n,5)*(0.8+Math.random()*0.4));
  const sync=async()=>{
    if(closed)return;
    if(inFlight){queued=true;return;}
    clearTimeout(poll);inFlight=true;
    try {await refresh();failures=0;onStatus({events:connected,snapshot:true});}
    catch {failures++;if(failures===1)diagnostic('snapshot-unavailable');onStatus({events:connected,snapshot:false});}
    finally {inFlight=false;if(!closed){const soon=queued;queued=false;poll=setTimeout(sync,failures?later(failures):soon?100:2000);}}
  };
  const arm=()=>{clearTimeout(watchdog);watchdog=setTimeout(()=>disconnect('heartbeat-timeout'),45000);};
  const disconnect=(reason='transport-error')=>{
    if(closed)return;
    diagnostic('reconnect-scheduled',{reason,attempt:attempt+1});
    connected=false;source?.close();clearTimeout(watchdog);clearTimeout(retry);
    onStatus({events:false});retry=setTimeout(open,later(attempt++));
  };
  const open=()=>{
    if(closed)return;
    try {source=new EventSource(url,{withCredentials:true});}
    catch {disconnect();return;}
    const current=source;
    arm();source.onopen=()=>{if(closed||source!==current)return;connected=true;diagnostic('events-connected');attempt=0;arm();onReconnect();return sync();};
    source.onerror=()=>{if(source===current)disconnect();};
    source.addEventListener('heartbeat',()=>{if(!closed&&source===current)arm();});
    for(const event of events)source.addEventListener(event,(message={})=>{if(closed||source!==current)return;arm();if(message.lastEventId && message.lastEventId===lastId)return;lastId=message.lastEventId||'';sync();});
  };
  const resume=()=>{if(document.visibilityState==='hidden')return;clearTimeout(retry);source?.close();open();sync();};
  const offline=()=>{source?.close();clearTimeout(retry);clearTimeout(watchdog);connected=false;onStatus({events:false,snapshot:false});};
  window.addEventListener('online',resume);window.addEventListener('offline',offline);document.addEventListener('visibilitychange',resume);
  open();sync();
  return ()=>{closed=true;source?.close();clearTimeout(poll);clearTimeout(retry);clearTimeout(watchdog);window.removeEventListener('online',resume);window.removeEventListener('offline',offline);document.removeEventListener('visibilitychange',resume);};
}
